import randomId from "../common/randomId";
import { Dashboard, Home, Login } from "../views";
import ProductDetail from "../views/Products/ProductDetail";
import Products from "../views/Products/Products";

const viewsUrls: any[] = [
    {
        id: randomId(),
        path: "/",
        exact: true,
        component: Home,
        type: "public"
    },
    {
        id: randomId(),
        path: "/products",
        exact: true,
        component: Products,
        type: "private"
    },
    {
        id: randomId(),
        path: "/product/:slug",
        exact: true,
        component: ProductDetail,
        type: "private"
    },
    {
        id: randomId(),
        path: "/products/:category",
        exact: true,
        component: Products,
        type: "private"
    },
    {
        id: randomId(),
        path: "/login",
        exact: true,
        component: Login,
        type: "public"
    },
    {
        id: randomId(),
        path: "/dashboard",
        exact: true,
        component: Dashboard,
        type: "private"
    }
];

export default viewsUrls;